export enum CookieKey {
  AccessToken = 'ACCESS_TOKEN',
  RefreshToken = 'REFRESH_TOKEN',
  IsReturner = 'IS_RETURNER',
  IsPmtReturner = 'IS_PMT_RETURNER',
  OnPageTimer = 'ON_PAGE_TIMER',
  OnPmtPageTimer = 'ON_PMT_PAGE_TIMER',
  IsFollowing = 'IS_FOLLOWING',
  IsLoggedIn = 'IS_LOGGED_IN',
  BrowserUuid = 'BROWSER_UUID',
  NewBrowserUuid = 'NEW_BROWSER_UUID',
  UserEmail = 'USER_EMAIL',
  FirebaseMessageToken = 'FIREBASE_MESSAGE_TOKEN',
  VerificationStatus = 'VERIFICATION_STATUS',
  PmtVerificationStatus = 'PMT_VERIFICATION_STATUS',
  IsValidVerification = 'IS_VALID_VERIFICATION',
  UserId = 'USER_ID',
  DownloadFileNames = 'DOWNLOAD_FILE_NAMES',
  SyncingESBannerExpiredTime = 'SYNCING_ES_BANNER_EXPIRED_TIME',
  HasGrantedAllAccess = 'HAS_GRANTED_ALL_ACCESS',
  LastValidIpInfoToken = 'LAST_VALID_IP_INFO_TOKEN',
  Ga4ClientId = 'GA4_CLIENT_ID',
  Ga4SessionId = 'GA4_SESSION_ID',
  UtmParams = 'UTM_PARAMS',
}
